/* @flow */

import $ from 'jquery';

const proximaEtapa = (id: string) => {
    $(`#${id} a`).click();
};

export default proximaEtapa;
